import React from 'react';

const Resume = ({ resumeData }) => {
  return (
    <section id="resume">
      <div className="row education">
        <div className="three columns header-col">
          <h1><span>Education</span></h1>
        </div>

        <div className="nine columns main-col">
          {
            resumeData.education && resumeData.education.map((item, index) => (
              <div key={`${item.UniversityName}-${item.YearOfPassing}-${index}`} className="row item">
                <div className="twelve columns">
                  <h3>{item.UniversityName}</h3>
                  <p className="info">
                    {item.specialization}
                    <span>&bull;</span> <em className="date">{item.MonthOfPassing} {item.YearOfPassing}</em>
                  </p>
                </div>
              </div>
            ))
          }
        </div>
      </div>

      <div className="row work">
        <div className="three columns header-col">
          <h1><span>Work</span></h1>
        </div>

        <div className="nine columns main-col">
          {
            resumeData.work && resumeData.work.map((item, index) => (
              <div key={`${item.CompanyName}-${item.YearOfStarting}-${index}`} className="row item">
                <div className="twelve columns">
                  <h3>{item.CompanyName}</h3>
                  <p className="info">
                    {item.specialization}
                    <span>&bull;</span> <em className="date">{item.MonthOfStarting} {item.YearOfStarting} - {item.YearOfLeaving ? `${item.MonthOfLeaving} ${item.YearOfLeaving}` : 'Present'}</em>
                  </p>
                  <p>{item.Achievements}</p>
                </div>
              </div>
            ))
          }
        </div>
      </div>

      <div className="row skill">
        <div className="three columns header-col">
          <h1><span>{resumeData.skillsDescription || 'Skills'}</span></h1>
        </div>

        <div className="nine columns main-col">
          <div className="bars">
            <ul className="skills">
              {
                resumeData.skills && resumeData.skills.map((item) => (
                  <li key={item.skillname}>
                    <span className={` ${item.skillname.toLowerCase()}`}></span><em>{item.skillname}</em>
                  </li>
                ))
              }
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Resume;
